
import { Vue, Component, Prop } from 'vue-property-decorator';
import { PartItem } from '@/features/shipment/types';
import { deletePartsBookItem } from '@/features/shipment/services/parts-book.services';
import {
  getPrice, showErrorAlertDialog, showSuccessAlertDialog, truncateText,
} from '@/features/common/helpers';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';

@Component
export default class PartsBookItem extends Vue {
  @Prop({ required: true }) item!: PartItem;

  private isDeleting = false;

  private truncateText = truncateText;

  get partsItemInPlainText(): string {
    const {
      quantity,
      quantityUnits,
      detailedDescription,
      countryOfOrigin,
      hsCode,
      unitValue,
    } = this.item;

    const quantityLabel = `${quantity} ${quantityUnits}`;

    const unitValueLabel = `${this.$t('labels.unitValue')}: ${getPrice(+unitValue, 2)}`;

    const hsCodeLabel = `${this.$t('labels.hsCode')}: ${hsCode}`;

    const values = [
      quantityLabel,
      countryOfOrigin,
      hsCodeLabel,
      unitValueLabel,
    ];

    let output = values.filter(Boolean).join(', ');

    if (detailedDescription) {
      output += `<br />${this.truncateText(detailedDescription, 80)}`;
    }

    return output;
  }

  private editPartsBookItem() {
    this.$emit('edit', this.item);
  }

  private deletePartsBookItem() {
    eventBus.$once(eventNames.CONFIRMATION_DIALOG, async () => {
      this.isDeleting = true;
      const isSuccess = await deletePartsBookItem(this.item.id as number);

      if (isSuccess) {
        this.$emit('delete', this.item.id);
        showSuccessAlertDialog(this.$t('alertDialog.partsBookDeleted') as string);
      } else {
        showErrorAlertDialog();
      }

      this.isDeleting = false;
    });

    this.$store.commit('toggleConfirmDialog', {
      show: true,
    });
  }
}
